import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'
import { initialState } from './slice'

const selectRadioState = (state: RootState) => state.Radio || initialState

export const radioSelector = createSelector([selectRadioState], Radio => Radio)
